export default "__VITE_ASSET__42556bb7__"